<section class="guest-flow-app-downloads" [attr.aria-label]="title">
  <div class="guest-flow-app-download-copy">
    <strong>{{ title }}</strong>
    <span>{{ description }}</span>
  </div>
  @if (showOpenLink && mobilePlatform && openUrl) {
    <a class="guest-flow-app-open-link" [href]="openUrl">
      {{ openLabel }}
    </a>
  }
  @if (showOpenLink && mobilePlatform && !openUrl) {
    <button type="button" class="guest-flow-app-open-link" [disabled]="opening" (click)="openRequested.emit()">
      {{ openLabel }}
    </button>
  }
  <div class="guest-flow-app-download-actions" [class.single-platform]="mobilePlatform">
    @if (showAndroidLink && androidUrl) {
      <a class="guest-flow-app-download-link"
        [href]="androidUrl"
        target="_blank"
        rel="noopener noreferrer">
        <i [class]="'auth.android' | nogoshIcon" aria-hidden="true"></i>
        <span>Android</span>
      </a>
    }
    @if (showIosLink && iosUrl) {
      <a class="guest-flow-app-download-link"
        [href]="iosUrl"
        target="_blank"
        rel="noopener noreferrer">
        <i [class]="'auth.apple' | nogoshIcon" aria-hidden="true"></i>
        <span>iOS</span>
      </a>
    }
  </div>
</section>
